import { render, staticRenderFns } from "./singleProperty.vue?vue&type=template&id=594b3677&scoped=true"
import script from "./singleProperty.vue?vue&type=script&lang=js"
export * from "./singleProperty.vue?vue&type=script&lang=js"
import style0 from "./singleProperty.vue?vue&type=style&index=0&id=594b3677&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594b3677",
  null
  
)

export default component.exports